import { classes } from 'state/product/config/DOM/classes'

export const attributes = Object.freeze({
  /*  -------- Product Container --------  */
  class: {
    container: {
      className: classes.class.container
      // id: 'prdPreviewHolder'
    }
  },

  color: {
    image: {
      className: classes.instance.image
    },
    swatch: {
      className: classes.instance.swatch,
      height: '17',
      width: '17'
    }
  },

  /*  -------- Product Instances --------  */
  // Unused: imageLink, price, reviewCount
  instance: {
    container: {
      className: classes.instance.container
    },
    // image: {
    //   className: classes.instance.image
    // },
    // link: {
    //   className: classes.instance.link
    // },
    rating: {
      className: classes.instance.rating
    },
    priceContainer: {
      className: classes.instance.priceContainer
    },
    salePrice: {
      className: classes.instance.salePrice
    },
    // swatch: {
    //   className: classes.instance.swatch,
    //   height: '17',
    //   width: '17'
    // },
    swatchContainer: {
      className: classes.instance.swatchContainer
    },
    title: {
      className: classes.instance.title
    }
  }
})
